import type {
  ListPrivacyRequestsResponse,
  PrivacyRequestStatsDto,
  PrivacyRequestStatus,
  PrivacyRequestSummaryDto,
  PrivacyRequestType,
  UpdatePrivacyRequestRequest,
} from '@bhops/shared';
import { apiClient } from './client';

export interface ListPrivacyRequestsQuery {
  status?: PrivacyRequestStatus;
  type?: PrivacyRequestType;
  assignedToId?: string;
  assignedToMe?: boolean;
  openOnly?: boolean;
  page?: number;
  pageSize?: number;
}

export const privacyRequestsApi = {
  async list(query: ListPrivacyRequestsQuery = {}): Promise<ListPrivacyRequestsResponse> {
    const { data } = await apiClient.get<ListPrivacyRequestsResponse>('/privacy-requests', {
      params: query,
    });
    return data;
  },

  async get(id: string): Promise<PrivacyRequestSummaryDto> {
    const { data } = await apiClient.get<PrivacyRequestSummaryDto>(`/privacy-requests/${id}`);
    return data;
  },

  async update(id: string, body: UpdatePrivacyRequestRequest): Promise<PrivacyRequestSummaryDto> {
    const { data } = await apiClient.patch<PrivacyRequestSummaryDto>(
      `/privacy-requests/${id}`,
      body,
    );
    return data;
  },

  async stats(): Promise<PrivacyRequestStatsDto> {
    const { data } = await apiClient.get<PrivacyRequestStatsDto>('/privacy-requests/stats');
    return data;
  },
};
